import {StatusLanguages} from "../../../types/admin";
import {STATUS_DRAFT, STATUS_PUBLISHED} from "../../../settings";

type Props = {
    languages: StatusLanguages[]
}

const AdminListLanguages = ({languages}: Props) => {
    const badgeBase = 'badge rounded-pill me-1';
    const badgeClass = (status: number) => {
        if (status === STATUS_PUBLISHED) {
            return `${badgeBase} bg-success`;
        } else if(status === STATUS_DRAFT){
            return `${badgeBase} bg-secondary`;
        }else{
            return `${badgeBase} bg-danger`;
        }
    }

    const renderLanguages = languages.map((language, index) => {
        return (
            <span key={`${index}-${language.language_code}`} className={badgeClass(language.status)}>{language.language_code}</span>
        )
    })

    return (
        <>
            {renderLanguages}
        </>
    )
}

export default AdminListLanguages;